import axios from 'axios';
import { get } from 'lodash/fp';
// import qs from 'qs';

import { API_URL } from '@source/constants/api';
import { TRegionKey } from '@source/interface';
import { ICreateAppointmentPayload, IGetTicketProps } from '@source/interface/appointment';
import { getBase64 } from '@source/pages/TransactionPayment/utils';

import { WHOLESALE_AXIOS_USER_AUTH } from './UserProfile';

export default {
  async getBySlug(country: TRegionKey, slug: string) {
    const url = `${API_URL(country).regionPathUrl}/tickets/${slug}`;
    const data = await WHOLESALE_AXIOS_USER_AUTH.get(url);
    return get(['data', 'data'])(data) as Record<string, any>;
  },
  createAppointment: (country: TRegionKey, ticketSlug: string, payload: ICreateAppointmentPayload) => {
    const createAppointmentAPI = `${API_URL(country).regionPathUrl}/tickets/${ticketSlug}/inspection-appointment`;

    return WHOLESALE_AXIOS_USER_AUTH.post(`${createAppointmentAPI}`, payload);
  },

  listAppointment: (country: TRegionKey) => {
    const appointmentListAPI = `${API_URL(country).regionPathUrl}/inspection-appointment`;

    return WHOLESALE_AXIOS_USER_AUTH.get(appointmentListAPI);
  },

  getAppointment: (country: TRegionKey, appointmentId: number) => {
    const appointmentDetailAPI = `${API_URL(country).regionPathUrl}/inspection-appointment/${appointmentId}`;
    return WHOLESALE_AXIOS_USER_AUTH.get(`${appointmentDetailAPI}`);
  },

  getAppointmentBufferTime: (country: TRegionKey) => {
    const appointmentBufferTime = `${API_URL(country).scheduleViewingBufferTime}`;
    return axios.get(appointmentBufferTime);
  },

  getTicketDetail: ({ payload, country }: IGetTicketProps) => {
    const { rabbitUrl } = API_URL();
    return WHOLESALE_AXIOS_USER_AUTH.post(`${rabbitUrl}/${country}/data-query/tickets`, payload);
  },

  uploadDocument: async (country: TRegionKey, ticketSlug: string, file: File) => {
    try {
      const base64String = await getBase64(file);
      const uploadAPI = `${API_URL(country).regionPathUrl}/tickets/${ticketSlug}/files`;
      return WHOLESALE_AXIOS_USER_AUTH.post(
        uploadAPI,
        {
          file: base64String,
        },
        {
          headers: {
            'Content-Type': 'application/json',
          },
        },
      );
    } catch (error) {
      throw error;
    }
  },

  verifyDocument: (country: TRegionKey, ticketId: string, fileId: string, type: 'b5_ic_ocr' | 'b5_company_info') => {
    const verifyAPI = `${API_URL(country).regionPathUrl}/tickets/${ticketId}/files/${fileId}/gpt-data?type=${type}`;
    return WHOLESALE_AXIOS_USER_AUTH.get(verifyAPI);
  },

  updateOwnership: (country: TRegionKey, ticketId: string, ownershipData: any) => {
    const ownershipAPI = `${API_URL(country).regionPathUrl}/tickets/${ticketId}/ownership`;
    return WHOLESALE_AXIOS_USER_AUTH.post(ownershipAPI, ownershipData);
  },
};
